import { Pipe, PipeTransform } from '@angular/core';
import { DocumentService } from '../../client-core/services';

@Pipe({ name: 'filterMarkedForDeletion' })
export class FilterMarkedForDeletion implements PipeTransform {

    constructor (){

    }

    /**
     * returns items from an arry that does not have markForDeletion flag set to true
     * @param items any array
     * @param args args[0] optional default url if document id is null
     */
    transform(items: any[], ...args: any[]) {
        console.log(">>filterMarkedForDeletion", items);
        if (items && items.length) {
            let filteredItems: any[] = items.filter(i => typeof (i.markedForDeletion) == undefined || !i.markedForDeletion);
            console.log(">>>>after filter", filteredItems);
            return filteredItems;
        }
        return items;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/filter.marked.for.deletion.pipe.ts